"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var __1 = require("..");
var styles = {
    root: {
        zIndex: 10,
        position: 'absolute',
        top: '50%',
        marginTop: '-20px',
        width: '40px',
        height: '40px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
    },
};
function CarouselControl(_a) {
    var _b;
    var type = _a.type, offset = _a.offset, onClick = _a.onClick;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ css: styles.root, style: (_b = {},
            _b[type] = offset,
            _b), onClick: onClick }, { children: (0, jsx_runtime_1.jsx)(__1.Icon, { name: type === 'left' ? 'arrowBack' : 'arrowForward' }, void 0) }), void 0));
}
exports.default = CarouselControl;
//# sourceMappingURL=CarouselControl.js.map